import lodash from "lodash";
import { BaseControl, Condition } from "@/oxygen/classes/lib/types";
import {
  getGlobalVariableFromInputValue,
  isGlobalVariable
} from "@/oxygen/variables/lib/utils";

export function showControl(
  conditions: BaseControl["conditions"],
  values: any = {}
) {
  if (conditions) {
    if (typeof conditions === "function") {
      return conditions();
    }

    const isSingle = conditions.some(c => typeof c === "string");

    const mappedConditions = (
      isSingle ? [conditions as Condition] : conditions
    ) as Condition[];

    return mappedConditions
      .map(c => shouldShowControl(c, values))
      .every(Boolean);
  }
  return true;
}

export function getControlValue(path: string, values: any) {
  const value = lodash.get(values, path);

  if (isGlobalVariable(value)) {
    const variable = getGlobalVariableFromInputValue(value);

    if (variable?.value) {
      return variable.value;
    }
  }

  return value;
}

export function shouldShowControl(
  condition: Condition,
  values: Record<string, unknown>
) {
  const [name, type, value] = condition;

  const currentValue = getControlValue(name, values);

  if (type === "==" && currentValue === value) {
    return true;
  }

  if (type === "!=" && currentValue !== value) {
    return true;
  }

  if (type === ">" && currentValue > value) {
    return true;
  }

  if (type === "<" && currentValue < value) {
    return true;
  }

  if (type === ">=" && currentValue >= value) {
    return true;
  }

  if (type === "<=" && currentValue <= value) {
    return true;
  }

  if (type === "in" && value.includes(currentValue)) {
    return true;
  }

  if (type === "not in" && !value.includes(currentValue)) {
    return true;
  }

  if (type === "contains" && currentValue.includes(value)) {
    return true;
  }

  if (type === "not contains" && !currentValue.includes(value)) {
    return true;
  }

  if (type === "starts with" && currentValue.startsWith(value)) {
    return true;
  }

  if (type === "ends with" && currentValue.endsWith(value)) {
    return true;
  }

  return false;
}
